$(document).ready(function(){
  $('.bxslider').bxSlider({
	  auto: true,
	  controls: false
	  /*prevImage: '/img/common/slidebnr_prev.png',
	  nextImage: '/img/common/slidebnr_next.png',	*/
	  });
});

